export default {
    "navigation": {
        "allWatchfaces": "すべてのアプリ",
        "faq": "FAQ",
        "helpCenter": "ヘルプと説明",
        "newsletter": "ニュースレター",
        "contact": "お問い合わせ",
        "weatherProvider": "天気プロバイダー",
        "tides": "潮汐",
        "colors": "色",
        "fonts": "フォント"
    },
    "homepage": {
        "title": "TitanicTurtle Apps",
        "subtitle": "すべてのアクティビティに対応した高度な機能を備えた最新のGarminアプリ",
        "newBadge": "新着",
        "filter": {
            "label": "Product filter",
            "watchfaces": "Watchfaces",
            "apps": "Apps",
            "all": "All",
            "noProducts": "No products in this category"
        }
    },
    "faq": {
        "title": "よくある質問",
        "subtitle": "ウォッチフェイスに関するよくある質問の回答を見つけてください",
        "tabs": {
            "search": "検索",
            "categories": "カテゴリ",
            "trending": "トレンド"
        },
        "search": {
            "placeholder": "ヘルプを検索...",
            "button": "検索",
            "suggestions": "人気の検索",
            "tips": {
                "title": "検索のヒント",
                "keywords": "\"GPS\"、\"天気\"、\"設定\"などの具体的なキーワードを使用してください",
                "language": "検索は選択した言語で機能します",
                "categories": "整理されたヘルプのためにカテゴリを閲覧してください"
            }
        },
        "noResults": {
            "title": "結果が見つかりません",
            "description": "異なるキーワードを試すか、カテゴリを閲覧してください",
            "browseCategories": "カテゴリを閲覧"
        },
        "suggestions": {
            "title": "人気の検索"
        },
        "trending": {
            "title": "トレンド検索"
        },
        "categories": {
            "title": "カテゴリ別に閲覧",
            "items": "項目",
            "allItems": "すべてのFAQ項目",
            "allItemsDescription": "すべてのよくある質問を閲覧",
            "noItems": {
                "title": "このカテゴリに項目がありません",
                "description": "別のカテゴリを選択してみてください"
            },
            "viewMore": "すべての項目を表示"
        },
        "results": {
            "title": "検索結果",
            "found": "件の結果が見つかりました",
            "total": "総結果",
            "bestMatch": "ベストマッチ",
            "categories": "カテゴリ",
            "sortBy": "並び替え",
            "sort": {
                "relevance": "関連性",
                "priority": "優先度",
                "category": "カテゴリ"
            },
            "lastUpdated": "最終更新",
            "matchedIn": "マッチした場所",
            "footer": "探しているものが見つかりませんでしたか？",
            "browseCategories": "カテゴリを閲覧",
            "viewTrending": "トレンドを表示",
            "contactSupport": "サポートに連絡"
        },
        "actions": {
            "copy": "コピー",
            "share": "共有",
            "copyAnswer": "回答をコピー",
            "copyAll": "すべてコピー"
        },
        "loading": "FAQを読み込み中...",
        "error": "読み込みエラー",
        "retry": "再試行"
    },
    "guides": {
        "backToHelp": "戻る",
        "purchase": {
            "title": "購入とインストール",
            "tabs": {
                "installation": "インストール",
                "versions": "VX / Elite バージョン",
                "troubleshooting": "トラブルシューティング"
            },
            "installation": {
                "title": "ConnectIQアプリでウォッチフェイスをインストール",
                "intro": "ウォッチフェイスは、AndroidまたはiOS用のGarmin ConnectIQアプリでウォッチにインストールできます。",
                "step1": "ウォッチをBluetoothでスマートフォンに接続し、スマートフォンでConnectIQアプリを開きます。",
                "step2": "インストールしたいウォッチフェイスのページに移動します。",
                "step3": "「インストール」ボタンをタップします。ウォッチフェイスはダウンロードキューに追加され、ウォッチにインストールされます。",
                "step4": "インストール後、アプリまたはウォッチにメッセージが表示され、ウォッチフェイスがデバイスで利用可能になります。",
                "noteScreen": "インストールおよび更新中は、スマートフォンの画面がオフにならないようにし、ConnectIQアプリを開いたままにしてください。",
                "selectWatchfaceTitle": "ウォッチでウォッチフェイスを選択する",
                "selectWatchfaceIntro": "ウォッチフェイスがインストールされているがまだ表示されない場合は、ウォッチのシステムメニューで選択する必要がある場合があります。",
                "select1": "ウォッチのメニューボタンを長押し（またはタッチスクリーンデバイスでは対応するボタン）してシステムメニューを開きます。",
                "select2": "「ウォッチフェイス」または「表示デザイン」のメニュー項目に移動します。",
                "select3": "インストール済みのすべてのウォッチフェイスのリストが表示されます。上下ボタンまたはタッチスクリーンで操作します。",
                "select4": "右上のボタンで選択したウォッチフェイスを確定します。ウォッチフェイスがウォッチで有効になりました。"
            },
            "versions": {
                "title": "VXとEliteの違いは？",
                "sameFeatures": "技術的には両バージョンは同一で、同じ機能を提供します。違いは購入とアクティベーションの方法のみです。",
                "eliteTitle": "Eliteバージョン（Garmin Pay）",
                "elite1": "ConnectIQストアでGarmin Pay経由で直接購入したウォッチフェイスの別インストール。",
                "elite2": "EliteバージョンはGarminアカウントに紐づきます。新しいウォッチを購入しても、追加のキーなしでEliteウォッチフェイスを再インストールできます。",
                "elite3": "Garmin Payはすべてのウォッチモデルでサポートされているわけではなく、すべての国で利用可能とは限りません。",
                "eliteNoKey": "重要：Garmin Pay経由でEliteバージョンを購入した場合、アンロックコードは送信されません。Eliteバージョンは購入後すぐにアンロックされ、コードは不要です。",
                "vxTitle": "VX / ウェブサイトバージョン",
                "vx1": "より多くのデバイスと互換性があり、Garmin Payが利用できない場合でも利用できることが多いです。",
                "vx2": "数日間の無料トライアル期間が組み込まれています。",
                "vx3": "トライアル後、このウェブサイトでアンロックコードを購入し、VXバージョン（またはプロ機能）を永続的にアンロックできます。",
                "vx4": "アンロックコードは購入したデバイス（WatchfaceID）専用で有効です。",
                "vx5": "ウォッチがGarminの保証で交換された場合、新しいキーを生成できます。その場合はお問い合わせフォームからサポートに連絡してください。"
            },
            "website": {
                "title": "ウェブサイトでの購入（VX / 通常バージョン）",
                "step1": "まずウォッチにウォッチフェイスをインストールしてください（インストールタブ参照）。WatchfaceIDはインストール後にウォッチフェイス設定に表示されます。",
                "step2": "ウォッチフェイス設定を開き（ConnectIQアプリまたはGarmin Express経由）、上部フィールドからWatchfaceIDをコピーします。",
                "step3": "このウェブサイトで該当するウォッチフェイスを選択し、購入フォームにWatchfaceIDを入力します。",
                "step4": "支払いを完了します。アンロックコードがメールで届くので、ウォッチフェイス設定のキーフィールドに入力できます。",
                "noteNoAutoInstall": "重要：ウェブサイト経由でアンロックコードを購入しても、ウォッチにウォッチフェイスは自動インストールされません。上記のインストール手順は手動で行う必要があります。"
            },
            "troubleshooting": {
                "installationTitle": "インストールの問題（キュー / 更新が止まる）",
                "installationIntro": "インストールが失敗したり、ウォッチフェイスが長時間キューに残ったり、ConnectIQアプリが終わりのない更新を報告することがあります。",
                "installationCause": "これは通常、ウォッチフェイス自体ではなく、ConnectIQアプリまたはGarminサービスに関係しています。",
                "installationFix1": "ウォッチを再起動し、スマートフォンのConnectIQアプリも再起動してください。",
                "installationFix2": "インストールを再試行し、処理中はスマートフォンの画面がオフにならず、ConnectIQアプリが開いたままになるようにしてください。",
                "garminPayTitle": "Garmin Pay購入が「処理中」のまま",
                "garminPayText": "ConnectIQストアでのGarmin Pay購入が長時間「処理中」のままの場合、これは完全にGarminが対応します。開発者としてGarmin Payシステムに影響はありません。その場合はGarmin公式サポートに連絡してください。",
                "noKeyTitle": "ウェブサイト購入後にアンロックキーが届かない",
                "noKey1": "まずメールの迷惑フォルダを確認してください。キー付きメールはそこに届くことが多いです。",
                "noKey2": "メールアドレスの誤字で届かないことがよくあります。メールが見つからない場合はお問い合わせください。",
                "noKey3": "支払いに使用したメールアドレスと、可能であればWatchfaceIDを含めてください。",
                "noKeyElite": "注：ConnectIQストアでGarmin Pay経由でEliteバージョンを直接購入した場合、アンロックコードは送信されません。Eliteバージョンは購入後すぐにアンロックされ、コードは不要です。"
            },
            "contactLink": "お問い合わせフォーム"
        },
        "timezones": {
            "title": "タイムゾーンとUTCオフセット",
            "basicsTitle": "第2・第3タイムゾーンとは？",
            "basicsText": "多くのウォッチフェイスで、2つの追加タイムゾーンを設定できます。通常「第2タイムゾーン」「第3タイムゾーン」と呼ばれ、ウォッチフェイス上の専用フィールドに表示されます。",
            "offsetTitle": "UTCオフセットの設定",
            "offsetIntro": "ウォッチフェイス設定には、第2・第3タイムゾーンのUTCからのオフセットを分で入力するフィールドが通常あります。",
            "offsetFormat": "1つ目の値が第2タイムゾーンのオフセット、2つ目が第3タイムゾーンのオフセットです。値は分で、スペースで区切ります。+は自動付与されないため、正の値は+なしで入力します。",
            "exampleLabel": "例：",
            "exampleExplanation": "ここでは第2タイムゾーンが-4.5時間（−270分）、第3が+2時間（+120分）のオフセットで、いずれもUTC基準です。",
            "changeExample": "第2タイムゾーンを+6時間にしたい場合、1つ目の値は360（6×60）にします。上記の例では次のようになります：",
            "advancedTitle": "詳細オプション（A/B/Cサフィックス）",
            "advancedOptionalHint": "このセクションは任意です。ウォッチフェイスがA/B/C形式サフィックスをサポートする場合にのみ関係します。",
            "advancedIntro": "ウォッチフェイスがこれらのサフィックスをサポートするかは、ウォッチフェイス設定のオフセット欄の上にある説明文に記載されています。サポートする場合、次のような説明が表示されることがあります：",
            "advancedExample": "UTC 第2・第3タイムゾーン オフセット（分、スペース区切り）（オフセット後の文字：A=12時間制、B=24時間制、C=軍用形式、空=標準）",
            "advancedNote": "これらのオプション文字（A/B/C）は、一部のウォッチフェイスで各タイムゾーンの表示形式を制御します。ウォッチフェイスの説明で言及されている場合にのみ使用してください。",
            "exampleSectionTitle": "ステップごと：さまざまな都市と形式の例",
            "exampleIntro": "次の例では、第2タイムゾーン（例：ニューヨーク）と第3タイムゾーン（例：東京）の設定方法と、各ゾーンで12時間/24時間表示を任意に選ぶ方法を示します。",
            "exampleStep1Title": "ステップ1：第2タイムゾーンのUTCオフセット",
            "exampleStep1Text": "第2タイムゾーンにする都市または地域を決め、UTCとの時差を分に換算します。例：ニューヨーク（EST、UTC−5）→ −300分。この値を設定欄の1つ目に入力します。",
            "exampleStep2Title": "ステップ2：第3タイムゾーンのUTCオフセット",
            "exampleStep2Text": "第3タイムゾーンも同様に。例：東京（JST、UTC+9）→ 540分。これが2つ目の値で、1つ目とスペースで区切ります。",
            "exampleOnlyOffsets": "ウォッチフェイスがA/B/Cサフィックスを使わない場合はここで完了。入力：",
            "exampleStep3Title": "ステップ3：任意の形式サフィックス（A/B/C）",
            "exampleStep3Optional": "このステップは任意です。ウォッチフェイスがサフィックスをサポートしていても省略でき、その場合はデフォルト形式になります。ゾーンごとに12時間・24時間・軍用形式を指定する場合は、オフセットの直後に文字を付けます（オフセットとサフィックスの間にスペースは入れません）。",
            "exampleStep3Text": "例：ニューヨークを12時間表示（A）、東京を24時間表示（B）にする場合：",
            "exampleStep3Note": "サフィックスなし＝ウォッチフェイスのデフォルト（多くの場合24時間）。サフィックスがサポートされているかは、ウォッチフェイス設定のオフセット欄の上の説明に記載されています。",
            "exampleFormatTitle": "A、B、Cでの時刻表示のされ方",
            "exampleFormatIntro": "同じ瞬間でも形式によって表示が異なります（例：第2ゾーン ニューヨーク -300、第3ゾーン 東京 540）。ライブプレビュー：",
            "zone2": "第2ゾーン",
            "zone3": "第3ゾーン",
            "exampleTableTitle": "参考：主要都市のUTCオフセット（分）",
            "exampleTableIntro": "標準時。夏時間は異なる場合があります。時間は60で掛けてください。"
        },
        "switchViews": {
            "title": "切り替えビューとジェスチャー操作",
            "wordLabel": "切り替えビュー",
            "basicsTitle": "切り替えビューとは？",
            "basicsText": "多くのウォッチフェイスでは、同じ画面領域で異なる情報を表示できます。これらの代替ページは設定で「Switchview」（{{wordLabel}}）、「Switchview 2」「上部ビュー1/2」「下部ビュー1/2」などと呼ばれることが多いです。",
            "proNote": "これらの追加ビューは多くの場合プロ機能で、トライアル期間中は利用可能で、その後はアクティベーションキーが必要です。",
            "gestureTitle": "手首ジェスチャーでビューを切り替える",
            "gestureIntro": "対応タッチスクリーンのないウォッチでは、2回目の手首の動きで代替ビューを切り替えられます。",
            "gestureStep1": "いつも通り手首を上げてディスプレイを起動します。秒表示または明るくなった画面がアクティブモードを示します。",
            "gestureStep2": "数秒以内（約7秒）に、もう一度手首を動かします。急にしすぎず、ウォッチが認識できる程度にはっきりと。",
            "gestureStep3": "ウォッチフェイスが切り替えビューをサポートしている場合、設定した領域（例：上部/下部ビュー）が次のページに切り替わります。",
            "gestureHint": "何も変わらない場合は設定を確認してください。一部のビューは明示的に割り当てる必要があります（例：「上部ビュー2」/「下部ビュー2」）。",
            "touchTitle": "タッチスクリーンデバイスでの切り替えビュー",
            "touchIntro": "対応タッチスクリーン搭載の新しいウォッチ（例：Fenix 7以降）では、特定のタッチゾーンを押してビューを切り替えられることが多いです。",
            "touchConfig": "多くのウォッチフェイスで、設定の下の方でこれらのゾーンを設定できます。典型的な例は時・分の数字や画面上の別領域です。",
            "touchHold": "タッチゾーンが設定されている場合、該当する数字/領域を長押しすると割り当てられたビューに切り替わります。",
            "touchMultiple": "上部ビュー用と下部ビュー用など、複数ゾーンを個別に割り当てられるウォッチフェイスもあります。",
            "touchInfo": "ウォッチフェイスに特別なゾーンがある場合は、このウェブサイトまたはConnectIQストアの説明文に記載されていることが多いです。"
        },
        "findWfId": {
            "title": "WatchfaceIDの見つけ方",
            "whatIs": "WatchfaceIDとは？",
            "whatIsExplanation": "各ウォッチフェイスにはデバイスごとに固有のWatchfaceIDがあります。5〜6桁の数字です。アクティベーションコードの購入やサポートに必要です。",
            "connectIqTitle": "ConnectIQアプリで（推奨）",
            "ciq1": "ウォッチがBluetoothでスマートフォンに接続されていることを確認してください。",
            "ciq2": "スマートフォンでConnectIQアプリを開きます。",
            "ciq3": "説明と画像があるウォッチフェイスのページに移動します。見つからない場合は下部の「検索」バーを使うか、「デバイス」の「マイウォッチフェイス」を確認してください。",
            "ciq4": "ウォッチフェイスページの「設定」ボタンを押してすべての設定を開きます。",
            "ciq5": "WatchfaceIDは上部のフィールドに表示されています。この番号をコピーまたは入力してください。これが支払いに必要なIDです。",
            "keyEntryTitle": "アクティベーションキーの入力",
            "keyEntryExplanation": "WatchfaceIDフィールドの下の行に、購入後に送られるキー/コード用のフィールドがあります。一部のウォッチフェイスでは残りトライアル日数が表示されます。キーを入力する前に削除してください。",
            "garminExpressTitle": "Garmin Express（デスクトップ）で",
            "ge1": "Garmin Expressをインストールし、ウォッチをパソコンに接続します。",
            "ge2": "インストール済みウォッチフェイスの一覧に移動します。",
            "ge3": "ウォッチフェイス横の3点ボタンをクリックして設定を開きます。",
            "ge4": "ConnectIQアプリと同じ手順に従います。",
            "geNote": "注：一部のGarmin Expressバージョンではエラーが出るため、ConnectIQアプリの利用を推奨します。",
            "zeroId": "WatchfaceIDが0と表示される？",
            "zeroIdExplanation": "WatchfaceIDが0と表示されることがあります。通常は設定を一度保存するかウォッチを再起動すると直ります。それでも0のままでも、支払いには問題ないことが多いです。"
        },
        "location": {
            "title": "GPS・位置情報の設定",
            "whatIsGpsFix": "GPSフィックスとは？",
            "gpsFixExplanation": "GPSフィックスでウォッチフェイスに現在地が伝わり、日の出/日の入り時刻、月相、天気の位置、潮汐を正しく計算できます。",
            "howTo": "GPSフィックスの方法",
            "step1": "ウォッチで任意のアクティビティの開始画面（例：「ランニング」）に移動します",
            "step2": "ウォッチがGPS信号を取得するまで待ちます（緑のバー/アイコン）",
            "step3": "ウォッチフェイスに戻ります。数分以内にデータが更新されるはずです",
            "alternative": "代替：スマートフォンのGPS",
            "alternativeExplanation": "スマートフォンのGPSを有効にすることもできます。ウォッチはBluetoothで接続されている必要があります。この方法は遅いですが同様に動作します。",
            "requirements": "要件",
            "req1": "ウォッチをBluetoothでスマートフォンに接続",
            "req2": "Garmin Connectアプリ（ConnectIQではない）が少なくともバックグラウンドで動作",
            "req3": "スマートフォンベースの位置情報のためスマートフォンでGPSを有効"
        },
        "settings": {
            "tabs": { "options": "データフィールドオプション", "change": "設定を変更", "troubleshoot": "トラブルシューティング" },
            "title": "ウォッチフェイス設定",
            "optionsIntro": "データフィールドオプションの一覧です。クリックで説明を表示。すべてのウォッチフェイスで利用できるとは限りません。",
            "change": {
                "title": "ウォッチフェイス設定の変更方法",
                "intro": "ウォッチフェイスの設定はスマートフォンのConnectIQアプリで変更できます。",
                "step1": "ウォッチをBluetoothでスマートフォンに接続し、ConnectIQアプリ（Connectではない）を開きます。",
                "step2": "ウォッチフェイスのページに移動します。未インストールの場合は先にインストールしてください。",
                "step3": "ウォッチフェイスページの「設定」ボタンをタップすると設定一覧が開きます。",
                "step4": "データフィールド、色、詳細オプションはここで変更できます。",
                "step5": "右上の保存ボタンをタップして設定をウォッチに転送します。",
                "installLink": "インストール手順"
            },
            "troubleshoot": {
                "title": "トラブルシューティング",
                "cantSave": { "q": "設定が保存できない", "a1": "Garminサーバーが特定の文字を処理できない場合があります。", "a2": "カラーテーマ欄（あれば）を空にしてから再度保存してみてください。" },
                "wontOpen": { "q": "設定が開かない", "a1": "ConnectIQアプリを完全に終了し、必要に応じてウォッチを再起動してください。", "a2": "「インストール」ボタンしか表示されない場合は、まだウォッチフェイスがインストールされていません。" },
                "missingOptions": { "q": "特定の設定オプションが見つからない", "a": "すべてのオプションがすべてのデバイスで利用できるわけではありません。" },
                "naValue": { "q": "フィールドに「n/a」とだけ表示される", "a": "お使いのデバイスはこのオプションをサポートしていません（機種が古い、または必要なハードウェアがない場合）。" }
            }
        },
        "dateFormat": {
            "title": "カスタム日付形式（日付 1 / 2 / 3）",
            "basicsTitle": "日付形式フィールドとは？",
            "basicsIntro": "ウォッチフェイス設定には、日付1・2・（対応時は）3の表示形式を設定するフィールドが2つ（または3つ）あります。入力する文字で表示形式が決まります。",
            "notAll": "すべてのウォッチフェイスで利用できるわけではありません。",
            "where": "日付形式の設定フィールドは、通常は設定一覧の下の方、データフィールドオプションの下にあります。",
            "codesTitle": "形式コード",
            "codesIntro": "形式フィールドには次の文字が使えます。表示は現在の日付に基づきます。",
            "codeD": "日（月内、ゼロ埋め）",
            "codeDText": "曜日（例：月曜日）",
            "codeM": "月（数字、ゼロ埋め）",
            "codeMText": "月（テキスト）",
            "codeY": "年（2桁）",
            "codeY4": "年（4桁）",
            "codeJ": "ユリウス日（ミリタリー）",
            "codeW": "週番号",
            "codeO": "月（ゼロ埋めなし）",
            "codeN": "日（ゼロ埋めなし）",
            "codeP": "年内の日",
            "exampleHint": "例：「D, d.M.Y」は「月, 27.02.2026」のように表示されます。"
        }
    },
    "themeInfo": {
        "howDoThemesWork": {
            "title": "テーマの仕組み：",
            "description": "ウォッチフェイス設定の上部に「テーマ文字列」があり、現在の色設定（アイコン、グラフ、時刻など）を表しています。何か変更（例：上部セクションの色）して「保存」を押すと、次に設定を開いたときにテーマ文字列が更新されます。こうしてテーマ文字列をコピーして別の場所に保存すれば色設定を残せます。レビューやフォーラムで他の人と共有したり、他の人のテーマ文字列を適用して別のスタイルを試すこともできます。"
        },
        "dynamicThemeSwitching": {
            "title": "動的テーマ切り替え：",
            "sunset": {
                "title": "日の入り後 / 日の出前に切り替え -",
                "description": "テーマ文字列フィールドで、切り替え先のテーマ文字列の前に感嘆符 ! を付けると、日の入り後に切り替わるテーマとして保存されます（例：!UEUE[UEUEEEEEEU^）。いつでも、先頭に ! を付けたテーマ文字列をフィールドに入れれば変更できます。夜用テーマを削除するには、フィールドに ! だけを入れると切り替えは行われなくなります。"
            },
            "lowPower": {
                "title": "省電力モードで切り替え -",
                "description": "上の日の入り/日の出用テーマ設定と同じ手順ですが、! の代わりにテーマ文字列の前に # を付けます（例：#UEUE[UEUEEEEEEU^）。ウォッチは画面を見てから約10秒後、またはメニューから戻ってから「省電力モード」に入ります。通常、省電力では秒表示は消えます（ウォッチフェイス設定で変更可能）。両方の切り替え（@夜/@省電力）を組み合わせられます。一度設定すると動的テーマ文字列はウォッチフェイス設定には表示されないので、将来変更する可能性がある場合は別の場所に保存しておいてください。"
            }
        }
    },
    "helpCenter": {
        "title": "ヘルプと説明",
        "subtitle": "ウォッチフェイス向けの回答・ガイド・説明",
        "guidesTitle": "ガイドと説明",
        "faqTitle": "よくある質問",
        "allCategories": "すべて",
        "guides": "ガイド",
        "faqResults": "FAQ",
        "noResults": "結果が見つかりません",
        "noResultsHint": "別のキーワードを試すか、下のカテゴリとガイドを閲覧してください。"
    },
    "watchfacesOverview": {
        "title": "すべてのアプリ",
        "loading": "ウォッチフェイスを読み込み中...",
        "error": "ウォッチフェイスの読み込みエラー",
        "retry": "再試行",
        "noWatchfaces": "利用可能なウォッチフェイスがありません"
    },
    "detailTabs": {
        "payment": "お支払い",
        "themes": "テーマ",
        "info": "情報",
        "instructions": "説明",
        "instructionsIntro": "すべてのガイドと説明を一覧で:",
        "noThemes": "このウォッチフェイスにはカラーテーマがありません。"
    },
    "watchfaceDetail": {
        "loading": "ウォッチフェイスを読み込み中...",
        "error": {
            "notFound": "ウォッチフェイスが見つかりません",
            "loading": "ウォッチフェイスの読み込みエラー"
        },
        "backToOverview": "一覧に戻る",
        "goToStore": "IQ Storeへ",
        "goToTrial": "トライアル版",
        "devices": "デバイス",
        "info": {
            "title": "機能",
            "tides": "🌊 潮汐情報（自動更新）",
            "weather": "🌤️ OpenWeatherMap・Yrの天気データ",
            "colors": "🎨 カラーテーマとカスタマイズ",
            "location": "📍 GPSによる位置情報",
            "faq": "❓ FAQとサポート",
            "weatherFallback": "One Call 3.0未加入の場合、OpenWeatherMap APIキーは「Yr」プロバイダーにフォールバックします。"
        }
    },
    "colorThemes": {
        "clickToCopy": "クリックでコピー",
        "clickToPreview": "クリックでプレビュー",
        "closePreview": "プレビューを閉じる",
        "copied": "コピーしました！",
        "useInSettings": "ウォッチフェイス設定で使用",
        "guideLink": "テーマ・テーマ文字列の詳細",
        "deviceNote": "カラーテーマはすべてのデバイスで利用できるわけではありません。",
        "noFieldNote": "ウォッチフェイス設定にカラースキーム用の個別フィールドがない場合、このウォッチフェイスではお使いの時計モデルでカラーテーマはサポートされていません。"
    },
    "payment": {
        "option1": {
            "title": "オプション1: Garmin Pay",
            "description": "ConnectIQ StoreでGarmin Payから有料ウォッチフェイスを購入（対応時計の場合）。",
            "link": "ConnectIQ Storeへのリンク"
        },
        "option2": {
            "title": "オプション2: WatchfaceIDで直接支払い",
            "description": "Pro版がお使いの時計に対応していない場合、WatchfaceIDを入力してトライアル/VX版キーを購入できます。",
            "vxNote": "これはVX版用のキーです。Garmin Pay版用ではありません。",
            "vxLink": "VX版へのリンク"
        },
        "tax": "税",
        "wfid": {
            "description": "WatchfaceIDを入力（ウォッチフェイス設定で確認）",
            "placeholder": "WatchfaceIDを入力（5〜6桁）",
            "guideLink": "WatchfaceIDの見つけ方",
            "guideLinkShort": "説明を表示"
        },
        "wfidError": {
            "letters": "WatchfaceIDは数字のみです",
            "tooLong": "WatchfaceIDは5〜6桁です",
            "invalid": "有効なWatchfaceIDを入力してください（5〜6桁）",
            "lengthHint": "WatchfaceIDは通常5〜6桁です。ご確認ください。"
        },
        "errors": {
            "empty": "WatchfaceIDを入力してください",
            "invalid": "有効なWatchfaceIDを入力してください",
            "config": "支払い設定エラー",
            "checkout": "支払いを開けませんでした。再試行してください。"
        },
        "buy": "今すぐ購入",
        "selectMethod": "バージョンを選択",
        "versionSelectHint": "これらは2つの別々のバージョンです — 正しいものを選択してください：",
        "vxWarning": "VX版とElite版はそれぞれ独立してダウンロード可能なウォッチフェイスです。VX版のアクティベーションコードではElite版はロック解除されません。",
        "beta": {
            "title": "現在ベータ版",
            "description": "このベータ期間中は、このウォッチフェイスを完全に無料でご利用いただけます。テスト期間終了後にも自動的に料金が発生することはありません。この期間中に新しい機能や改善点のテストを行っています。フィードバックありがとうございます！",
            "descriptionApp": "このベータ期間中は、このアプリを完全に無料でご利用いただけます。テスト期間終了後にも自動的に料金が発生することはありません。この期間中に新しい機能や改善点のテストを行っています。フィードバックありがとうございます！"
        },
        "elite": {
            "badge": "Garmin Pay",
            "title": "Elite版",
            "description": "このウォッチフェイスはConnectIQ StoreのGarmin Payでのみ購入できます。",
            "comboDescription": "ConnectIQ StoreでGarmin Payから購入。別の単体版です。",
            "compatibility": "Garmin Payはすべての時計でサポートされていません。Storeページで互換性を確認してください。それ以外はVX版（機能的に同一）をダウンロードしてください。",
            "storeLink": "ConnectIQ Storeで開く",
            "moreGuide": "Elite版とVX版の違いについて詳しく",
            "moreGuideLink": "購入・インストールガイドを読む",
            "eliteNoKey": "Garmin PayでElite版を購入してもアンロックコードは送信されません。Elite版は購入後すぐにアンロックされ、コードは不要です。",
            "accountBound": "Garmin Payでの購入はGarminアカウントに紐付けられ、将来のデバイスでも自動的に利用可能です（互換性がある場合）。",
            "eliteNoKeyAndGuide": "Garmin Payで購入してもアンロックコードは送信されません — Elite版は購入後すぐにアンロックされます。詳しくは購入・インストールガイドをご覧ください。"
        },
        "vx": {
            "badge": "全デバイス対応",
            "title": "VX版",
            "description": "対応デバイスで利用可能。ConnectIQ Storeから無料トライアルをダウンロードし、ここで購入したコードで有効化。",
            "trialNote": "VX版にはトライアル期間があります。その後、下でアクティベーションコードを購入してアンロック。",
            "deviceBound": "アクティベーションコードはデバイスに紐付けられ、VX版を永久にアンロックします。",
            "moreGuide": "VX版・キー・インストールについて詳しく",
            "moreGuideLink": "購入・インストールガイドを読む",
            "downloadLink": "VX版をダウンロード",
            "details": {
                "line1": "支払い完了後、次のステップで入力したメールアドレスにアクティベーションキーが送信されます。",
                "line2": "メールアドレスが正しいか確認してください。",
                "line3": "支払い後に迷惑メールフォルダを確認してください。キー付きメールはそこに届くことがあります。",
                "line4": "すべての支払いはPaddleが処理。アカウント不要。",
                "line5": "サポートはお問い合わせフォームまたはConnectIQ Storeツールをご利用ください。",
                "line6": "その他のお問い合わせは対応できかねます。"
            }
        },
        "standalone": {
            "title": "アクティベーションコードを購入",
            "description": "下にWatchfaceIDを入力してアクティベーションコードを購入。コードはすぐに送信されます。"
        },
        "checkoutOpening": "支払いを開いています...",
        "info": {
            "key": "購入後、ウォッチフェイス設定で入力するキーが届きます。",
            "activation": "キーは支払い完了後すぐに有効になります。",
            "support": "ご質問はサポートまで。",
            "moreGuide": "購入・インストールの詳細"
        },
        "methods": {
            "applePay": "Apple Pay",
            "googlePay": "Google Pay",
            "alipay": "Alipay",
            "paypal": "PayPal",
            "creditCard": "クレジットカード"
        }
    },
    "footer": {
        "tagline": "すべてのアクティビティに対応した高度な機能を備えた最新のGarminアプリ。",
        "description": "すべてのアクティビティに対応した高度な機能を備えた最新のGarminアプリ。"
    },
    "newsletter": {
        "title": "ニュースレター",
        "description": "新作ウォッチフェイス・機能・キャンペーンのお知らせを受け取るにはニュースレターに登録してください。",
        "frequencyHint": "おおよそ2ヶ月に1通のメール。いつでも配信停止できます。",
        "emailPlaceholder": "メールアドレス",
        "subscribe": "登録",
        "unsubscribe": "配信停止",
        "subscribeSuccess": "登録完了！メールをご確認ください。",
        "subscribeError": "エラーが発生しました。しばらくしてから再度お試しください。",
        "unsubscribeSuccess": "配信を停止しました。",
        "unsubscribeError": "エラーが発生しました。しばらくしてから再度お試しください。"
    },
    "fonts": {
        "title": "フォント",
        "timefonts": "時刻フォント",
        "datafonts": "データフォント"
    },
    "common": {
        "loading": "読み込み中...",
        "error": "エラー",
        "retry": "再試行",
        "back": "戻る",
        "close": "閉じる",
        "save": "保存",
        "cancel": "キャンセル",
        "confirm": "確認",
        "notFound": "404 – ページが見つかりません"
    },
    "bierwander": {
        "title": "Bierwandern",
        "intro": "Bierwandernアプリで、ハイキングと途中で楽しむおかわりを記録できます。さらに、血中アルコール濃度の推定値とチャート（おおよその目安）も表示されます – あまり真剣に受け取らないでください！",
        "settingsHint": "スタート画面で時計のメニューボタンを押して設定メニューを開きます（2ボタンレイアウトの時計では、タッチスクリーンを長押し）。",
        "disclaimer": "プロミル計算はあくまで娯楽用の指標です – 消費した飲み物と体重から血中アルコール濃度を推定するアルゴリズムです！この値に基づいて判断しないでください – 信頼性がなく、実際のアルコール測定ではありません！",
        "closing": "それでは、良いハイキングと楽しい時間を！",
        "support": "問題や改善提案がある場合は「App Support」ボタンをご利用ください – ありがとうございます。"
    },
    "bodysurf": {
        "intro": {
            "title": "BodySurfとは？",
            "text": "BodySurfはボディサーフィン用のGarmin Connect IQウォッチアプリです。GPSで波への乗りを検出し、各ライドの距離と時間を計測し、走行距離に応じた楽しいタイトルを付けます。セッションはGarmin Connectのアクティビティとして個別のラップ付きで保存されます。"
        },
        "gps": {
            "title": "開始前 – GPS",
            "text1": "セッション開始前にGPSフィックスを待ってください。開始画面では信号が得られるまで「GPSを検索中」、その後「STARTで開始」と表示されます。",
            "text2": "精度向上のため、対応ウォッチではマルチGNSS／デュアルバンドGPSを使用します。フィックスに時間がかかる場合は水辺で少し静止してください。"
        },
        "start": {
            "title": "スタート画面",
            "startBtn": "GPS準備完了後に新しいセッションを開始（START = セッションを開始）。",
            "menuBtn": "設定を開く：使い方と単位（MENU = 設定 / 情報）。",
            "backBtn": "BACK = アプリを終了"
        },
        "during": {
            "title": "アクティビティ中",
            "detect": "ライドはGPSで検出されます速度自動的に。BACKを使用して手動でライドを開始/停止します。約2m未満の短い動きは無視されます。",
            "startBtn": "START = 停止 / 保存 / 再開",
            "backBtn": "BACK = 手動ライドのオン/オフ",
            "live": "ライド中は現在距離、ライブタイトル、「ライディング中！」が表示されます。ライド終了後、次のライドまでタイトルと統計が表示されます。"
        },
        "stop": {
            "title": "停止メニュー",
            "resume": "再開",
            "save": "保存",
            "discard": "破棄"
        },
        "after": {
            "title": "セッション後",
            "summary": "概要にはセッション時間、ライド数、総距離、ベストライドのタイトルと統計が表示されます。",
            "rides": "スワイプしてライドの詳細を見る。ボタン式ウォッチでは<< DOWN rides。",
            "finished": "終了後：STARTで新しいセッション、BACKでアプリを終了。"
        },
        "titles": {
            "title": "ライドタイトル",
            "intro": "各ライドには楽しいタイトルが付けられます距離に基づいています。長いほどタイトルが良くなります！",
            "colDistance": "距離",
            "colTitle": "タイトル",
            "th0": "シーキュウリ",
            "th1": "フランダー",
            "th2": "人間のサーフボード",
            "th3": "ウェーブライダー",
            "th4": "アクアマン",
            "th5": "ポセイドン",
            "th6": "ネプチューン",
            "th7": "波の征服者",
            "th8": "マイスターライダー",
            "th9": "波の神",
            "th10": "海の伝説",
            "th11": "波のタイタン",
            "th12": "海の王"
        },
        "connect": {
            "title": "Garmin Connect",
            "text": "保存されたセッションはGarmin Connectに表示され、ライドタイトル、ラップ距離（m）、ラップ時間（秒）、最長ライド／時間などのカスタムフィールドが含まれます。検出された各ライドはラップとして保存されます。"
        },
        "instinct": {
            "title": "Instinct 2 / 3 (MIP)",
            "layout": "Instinctではサブディスプレイに時間、GPS、ライド距離を表示。スワイプの代わりにDOWNボタン（<< DOWN rides）。",
            "menu": "開始画面左に「メニュー」。サブディスプレイにGPS OKと表示されたらSTARTを押してください。"
        },
        "settings": {
            "title": "設定",
            "units": "単位：距離と速度のメートル法／ヤード・ポンド法を切り替え。",
            "info": "情報：ウォッチ内ヘルプ（使い方）で操作中・セッション後・開始画面のボタン説明。"
        },
        "supportBefore": "問題や提案がある場合は",
        "supportLink": "お問い合わせフォーム",
        "supportAfter": "をご利用ください。"
    }
};
